import {Progress} from "antd";
import React from "react";
import "./QuestionBody.scss";

interface IProps {
  level: number;
  question: string;
  percent: number;
}

const QuestionBody = (props: IProps) => {

  return (
    <div id="question-body">
      <div className="body">
        <span className="question-level">{props.level})</span>
        <span className="question-text">{props.question}</span>
      </div>
      <Progress
        className="timer"
        percent={props.percent}
        showInfo={false}
        strokeColor="#FF4949"
        strokeLinecap="square"
      />
      <div className="layer layer-1"/>
      <div className="layer layer-2"/>
    </div>
  );
}

export default QuestionBody;
